import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const TransferHIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.7071 5.29289C13.3166 4.90237 12.6834 4.90237 12.2929 5.29289C11.9024 5.68342 11.9024 6.31658 12.2929 6.70711L12.5858 7H5.00003C4.44774 7 4.00003 7.44772 4.00003 8C4.00003 8.55228 4.44774 9 5.00003 9H15C15.4045 9 15.7691 8.75636 15.9239 8.38268C16.0787 8.00901 15.9931 7.57889 15.7071 7.29289L13.7071 5.29289Z"/>
      <path d="M6.29292 14.7071C6.68345 15.0976 7.31661 15.0976 7.70714 14.7071C8.09766 14.3166 8.09766 13.6834 7.70714 13.2929L7.41424 13L15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11L5.00003 11C4.59557 11 4.23093 11.2436 4.07615 11.6173C3.92137 11.991 4.00692 12.4211 4.29292 12.7071L6.29292 14.7071Z"/>
    </svg>
  </span>
);

export default TransferHIcon;
